<template>
	<el-dialog :modal-append-to-body="false"
		:visible.sync="visible"
		title="充值申请"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		width="900px"
	>
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
			<el-row>
				<el-col :span="12">
					<el-form-item label="付款公司：" prop="payerName"><el-input style="width: 95%;" v-model="dataForm.payerName" placeholder="付款公司"></el-input></el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="收款公司：" prop="bodyId">
						<el-select style="width: 95%;" v-model="dataForm.bodyId" placeholder="收款公司" clearable>
							<el-option v-for="platBody in platBodyList" :key="platBody.id" :label="platBody.bodyName" :value="platBody.id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="付款总金额：" prop="amount"><el-input style="width: 95%;" v-model="dataForm.amount" placeholder="付款总金额"></el-input></el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="服务费金额：" prop="fee"><el-input style="width: 95%;" v-model="dataForm.fee" placeholder="服务费金额"></el-input></el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="充值金额：" prop="operator"><el-input style="width: 95%;" v-model="dataForm.amount-dataForm.fee" placeholder="充值金额" disabled="true"></el-input></el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="备注：" prop="remark">
						<el-input type="textarea"  rows="4" style="width: 95%;" v-model="dataForm.remark" placeholder="备注" :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="银行回单：" prop="receipt">
						<el-row>
							<el-col v-if="receipt.length > 0" :span="10">
								<img v-if="receipt[0] && receipt[0].indexOf('pdf')===-1" :src="receipt[0]" class="avatar">
								<img v-else-if="receipt[0] && receipt[0].indexOf('pdf')!==-1" :src="require('../../../assets/img/pdf.png')" class="avatar">
							</el-col>
							<el-col :span="10">
								<el-upload
								  class="avatar-uploader"
								  :action="url"
								  :show-file-list="false"
								  :before-upload="beforeUploadHandle"
								  :on-success="successHandle"
									:on-error="backerror"
								  >
									<i class="el-icon-plus avatar-uploader-icon"></i>
								  <div slot="tip" class="el-upload__tip">支持上传PDF、图片等</div>
								</el-upload>
							</el-col>
							<el-col :span="4" v-if="receipt.length > 0" >
								<img :src="require('../../../assets/img/more.png')" @click="showmsg()" style="width: 30px;height: 30px;"/>
							</el-col>
						</el-row>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<template slot="footer">
			<el-button @click="visible = false">{{ $t('cancel') }}</el-button>
			<el-button type="primary" @click="dataFormSubmitHandle()" :loading="loadingbut">{{ $t('confirm') }}</el-button>
		</template>
		<el-dialog :modal-append-to-body="true" append-to-body="true" :modal="false" title="银行回单" width="700px" custom-class="dialogBg" :show-close="false" top="264px" center :visible.sync="dialogVisible">

			<el-row>
				<el-col v-for="item in receipt" :key="index" :offset="1" v-if="receipt.length > 0" :span="8">
					<img v-if="item && item.indexOf('pdf')===-1" :src="item" class="avatar" @click="yulan(item)">
					<img v-else-if="item && item.indexOf('pdf')!==-1" :src="require('../../../assets/img/pdf.png')" class="avatar" @click="yulan(item)">
					<el-button type="primary" @click="deleteimg(index)">删除</el-button>
				</el-col>
			</el-row>
			<template slot="footer">
			  <el-button @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
			</template>
		</el-dialog>
	</el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      visible: false,
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      num: 0,
      platBodyList: [],
      dialogVisible: false,
      receipt: [],
      dataForm: {
        userId: '',
        payerName: '',
        amount: '',
        fee: '',
        bodyId: '',
        remark: '',
        receipt: ''
      },
      type: '',
      loadingbut: false
    }
  },
  computed: {
    dataRule () {
      var checkNum = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入数字值,并且最多两位小数'))
        }
      }
      return {
        payerName: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        bodyId: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        amount: [{ required: true, message: '请输入数字值,并且最多两位小数', validator: checkNum, trigger: 'blur' }],
        fee: [{ required: true, message: '请输入数字值,并且最多两位小数', validator: checkNum, trigger: 'blur' }],
        tax: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        total: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        billingDate: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        receipt: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }]
      }
    }
  },
  methods: {

    init () {
      this.visible = true
      this.getPlatBodyList()
      this.receipt = []
      this.$nextTick(() => {
        if (this.dataForm.userId == '') {
          this.getinfo()
        }
        this.$refs['dataForm'].resetFields()
      })
    },

    showmsg () {
      this.dialogVisible = true
    },
    getinfo () {
      this.$http
        .get('/sys/plat/info/ca/getInfoByUser')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm.payerName = res.data.caName
        })
        .catch(() => {})
    },
    // 获取我方主体列表
    getPlatBodyList () {
      this.$http
        .get('/sys/plat/body/list')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.platBodyList = res.data
        })
        .catch(() => {})
    },
    beforeUploadHandle (file) {
		  if (file.type != 'application/pdf' && file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
		    this.$message.error(this.$t('upload.tip', { 'format': 'jpg、png、gif,pdf' }))
		    return false
		  }
		   if (file.size / 1024 / 1024 > 30) { this.$message.error('文件太大，只能上传30MB以内的文件'); return false }
		  this.num++
    },
    // 上传成功
    successHandle (res, file, fileList) {
		  if (res.code !== 0) {
		    return this.$message.error(res.msg)
		  }
		  if (res.code == 0) {
			 this.receipt.push(res.data.url)
			 this.dataForm.receipt = this.receipt.join(',')
		  } else {
			  this.$message.error('上传失败，请重试')
		  }

		  this.num--
    },
    yulan (e) {
      window.open(e, e)
    },
    backerror (e) {
      this.$message.error('文件上传失败，请重试')
    },
		  deleteimg (index) {
			  this.receipt.splice(index, 1)
			  this.dataForm.receipt = this.receipt.join(',')
		  },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs['dataForm'].validate(valid => {
          if (!valid) {
            return false
          }
          this.loadingbut = true
          this.$http.post('/sys/account/charge/apply', this.dataForm, {
            headers: {
              'content-type': 'application/json;charset=UTF-8'
            }
          }).then(({ data: res }) => {
            this.loadingbut = false
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    )
  }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>
